import {useNavigate, NavLink} from "react-router-dom"
import Swal from "sweetalert2"
function SideBar(){
    const navigate= useNavigate()
    const toLogin= ()=>{
        localStorage.clear()
        navigate('/login')
        Swal.fire({
            icon: 'success',
            title: 'Log Out success'
        })
    }
    const activate= 'text-green-300'
    const nonActivate= ''
    return(
        <nav>
            <div className="h-screen w-44 bg-blue-500 flex flex-col fixed">
            <img src="https://d3g5ywftkpzr0e.cloudfront.net/wp-content/uploads/2020/01/15094433/hacktiv8-1.png" alt="" style={{width:"200px"}} />
            <div className= "font-semibold text-white">
            <div className="hover:border ml-2 mr-2 h-8 pt-0.5 pl-2 rounded-lg">
            <NavLink to="/" className={({isActive})=> isActive ? activate: nonActivate }>HOME</NavLink>
            </div>
            <div className="hover:border mt-3 ml-2 mr-2 h-8 pt-0.5 pl-2 rounded-lg">
            <NavLink to="/genre"  className={({isActive})=> isActive ? activate: nonActivate }>Genre</NavLink>
            </div>
            <div className="hover:border mt-3 ml-2 mr-2 h-8 pt-0.5 pl-2 rounded-lg">
            <NavLink to="/register"  className={({isActive})=> isActive ? activate: nonActivate }>Register Admin</NavLink>
            </div>
            <div className="hover:border mt-3 ml-2 mr-2 h-8 pt-0.5 pl-2 rounded-lg">
            <button onClick={()=>{toLogin()}}>Log Out</button>
            </div>
            </div>
            </div>
        </nav>
        
    )
}

export default SideBar